<div
    class="lg-sidebar__body"
    [class.lg-sidebar__body--expanded]="_visible && _pinned"
    [class.lg-sidebar__body--slideout]="_visible && !_pinned"
    lgArrowNavigation
    [horizontalNavigation]="false"
>
    <div class="lg-sidebar__top">
        @for (widget of _topWidgets | async; track widget) {
            <ng-container
                *ngTemplateOutlet="
                    widget.widgetTemplate || buttonTemplate;
                    context: { $implicit: widget }
                "
            ></ng-container>
        }
    </div>
    <div class="lg-sidebar__bottom">
        @for (widget of _bottomWidgets | async; track widget) {
            <ng-container
                *ngTemplateOutlet="
                    widget.widgetTemplate || buttonTemplate;
                    context: { $implicit: widget }
                "
            ></ng-container>
        }
    </div>
    <ng-template #buttonTemplate let-button>
        <div
            class="lg-sidebar-btn {{ button.buttonClass }}"
            (click)="_toggle(button)"
            (keydown.enter)="_toggle(button)"
            [class.lg-sidebar-btn--with-tooltip]="showNameAsTooltip"
            [class.lg-sidebar-btn--active]="button === _selectedButton || button.isActive"
            [class.lg-sidebar-btn--always-visible]="button.nameAlwaysVisible"
            [class.lg-sidebar-btn--disabled]="button.disabled"
            [lgSimpleTooltip]="showNameAsTooltip ? button.nameLc : ''"
            [tooltipPosition]="'right-top'"
            [tooltipClass]="'lg-tooltip lg-tooltip--simple lg-tooltip--sidebar'"
            role="button"
            tabindex="0"
        >
            @if (button.icon) {
                <lg-icon
                    [icon]="button.icon"
                    [size]="button.large ? 'medium' : 'regular'"
                    class="lg-sidebar-btn__icon"
                ></lg-icon>
            }
            @if (button.imageClass) {
                <div class="{{ button.imageClass }} lg-sidebar-btn__image"></div>
            }
            @if (!showNameAsTooltip) {
                <div class="lg-sidebar-btn__name {{ button.nameClass }}">
                    {{ button.nameLc | lgTranslate }}
                </div>
            }
            @if (button.badge > 0) {
                <div class="lg-sidebar-btn__badge">
                    {{ _clamp(button.badge) }}
                </div>
            }
        </div>
    </ng-template>
</div>
@if (!_pinned && _selectedButton != null) {
    <div class="lg-sidebar-panel__underlay" (click)="_toggle(_selectedButton)"></div>
}
<lg-sidebar-panel-holder
    #holder
    [sidebar]="this"
    [panel]="_selectedButton"
    [pinned]="_pinned"
    [noFocus]="_shownBySavedState"
    (pinClicked)="_togglePin()"
    (hidden)="_panelHidden()"
    (hide)="_escape()"
/>
